import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSnackbar } from "../../hook/useSnackbar";
import { useUserContext } from "../../userContext";
import { useZammadContext } from '../../context/ZammadContext';
import { useVariableContext } from '../../variableContext';
import { SEARCH_TICKETS_ZAMMAD, mapZammadStateToDisplay } from "../../utils/ZammadServices";
import estructuraFormularios from '../../data/estructuraFormularios.json';
import Table from '../../lib/table/table-component'; 

export default function Listado() {

  const { idForm } = useParams();
  const { showSnackbar } = useSnackbar();
  const { startLoader, stopLoader } = useUserContext();
  const { zammadInstance, zammadUser } = useZammadContext();
  const { root } = useVariableContext();
  const [columnsFrm, setColumnsFrm] = useState([]);
  const [valuesRegister, setValuesRegister] = useState([]);
  const [nextLink, setNextLink] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const idListSolicitudes = idForm;
  const cantidadElementos = 10; //Cantidad de elementos por pagina;


  useEffect(() => {
    const fetchData = async () => {
      try {
        await startLoader();

        // Cargar estructura del formulario desde JSON, solo campos específicos
        const estructuraFormulario = estructuraFormularios[idListSolicitudes];
        if (estructuraFormulario) {
          // Filtrar solo los campos que queremos mostrar en la tabla
          const camposFiltrados = estructuraFormulario.campos.filter(campo =>
            ['Title', 'aplicacion_busint', 'modulo'].includes(campo.name)
          );
          setColumnsFrm(camposFiltrados);
        }

        await loaderDataInit();
        await stopLoader();
      } catch (error) {
        await stopLoader();
        console.log(error)
        showSnackbar(
          "Error : " + error.message,
          "error"
        );
      }
    };

    if (zammadInstance && zammadUser) {
      fetchData();
    }

    return () => {
      // Cualquier código de limpieza aquí
    };
  }, [zammadInstance, zammadUser]);  


  const loaderDataInit = async (page = 1) => {
    if (!zammadUser) {
      return;
    }

    // Buscar tickets del usuario actual en el grupo y tipo de incidencia, excluyendo estado 4 (Cerrado)
    const tipoSolicitud = root.ListadoApp?.find(x => x.idLista === idForm);
    const grupoZammad = tipoSolicitud?.GrupoZammad || 2;
    const tipoIncidencia = tipoSolicitud?.tipo_incidencia || 'soporte_tecnico';

    const query = `customer_id:${zammadUser.id} AND group_id:${grupoZammad} AND tipo_incidencia:${tipoIncidencia} AND NOT state_id:4`;

    const responseTickets = await SEARCH_TICKETS_ZAMMAD(
      zammadInstance,
      query,
      cantidadElementos * page
    );

    // Transformar datos de Zammad a formato esperado por la tabla
    const ticketsTransformados = responseTickets.data.map(ticket => ({
      id: ticket.id,
      Title: ticket.title,
      Estado: mapZammadStateToDisplay(ticket.state_id),
      Numero: ticket.number,
      FechaCreacion: ticket.created_at,
      aplicacion_busint: ticket.aplicacion_busint,
      modulo: ticket.modulo,
      group_id: ticket.group_id,
      ...ticket
    }));

    setValuesRegister(ticketsTransformados);

    // Zammad maneja paginación diferente, ajustar según necesidad
    setNextLink(responseTickets.data.length >= cantidadElementos ? page + 1 : '');
  }

  const nextPageLoader = async () => {
    try {
      await startLoader();
      const nextPage = currentPage + 1;
      await loaderDataInit(nextPage);
      setCurrentPage(nextPage);
      await stopLoader();
    } catch (error) {
      await stopLoader();
      console.log(error)
        showSnackbar(
          "Error : " + error.message,
          "error"
        );
    }
  }

  return (
      <Table
        columnsFrm={columnsFrm}
        valuesRegister={valuesRegister}
        nextLink={nextLink}
        nextPageLoader={nextPageLoader} />
  );
} 